import React, { useEffect, useState } from "react";
import MainLayout from "../../Layout/mainLayout";
// import InnerHeading from "../../Global Functions/innerHeading";
import { ReactComponent as Franchise } from "../../Global Icons/Franchise.svg";
import { useNavigate } from "react-router-dom";
import TextInput from "../../Global Functions/textInput";
import SelectInput from "../../Global Functions/selectInput";
import { useDispatch, useSelector } from "react-redux";
import {
  viewCountryListPagination,
  viewStateListPagination,
  viewCityList,
} from "../../Redux/Actions/settingsActions";
import {
  sendFranchiseOtp,
  verifyFranchiseOtp,
  addFranchise,
} from "../../Redux/Actions/franchiseAction";
import { ScrollTop } from "../../Utils/helpers";
import toast from "react-hot-toast";
import TwoButtons from "../../Global Functions/buttons";
import AddImage from "../../Global Functions/addImage";
import "./addFranchise.css";

import { PhonecodeSelect } from "react-country-state-city";
import "react-country-state-city/dist/react-country-state-city.css";

import { FaEye, FaEyeSlash } from "react-icons/fa";

const AddFranchise = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { countryList } = useSelector((state) => state.country || {});
  const { states } = useSelector((state) => state.states || {});
  const { cities } = useSelector((state) => state.city || {});
  const { user } = useSelector((state) => state.auth || {});

  const [referralState, setReferralState] = useState({
    brand_name: "",
    brand_logo: "",
    organization_name: "",
    primary_country_code: "",
    primary_contact_number: "",
    primary_email: "",
    street_address: "",
    city: "",
    state: "",
    country: "",
    rera_id: "",
    pwd: "",
    confirm_pwd: "",
    status: "active",
  });
  const [isNumberEditable, setIsNumberEditable] = useState(false);
  const [isEmailEditable, setIsEmailEditable] = useState(false);

  // OTP states and IDs to store otp_id from send-otp response
  const [otpNumber, setOtpNumber] = useState("");
  const [otpEmail, setOtpEmail] = useState("");
  const [otpIdNumber, setOtpIdNumber] = useState(null);
  const [otpIdEmail, setOtpIdEmail] = useState(null);

  const [isNumberVerified, setIsNumberVerified] = useState(false);
  const [isEmailVerified, setIsEmailVerified] = useState(false);

  // For image preview URL
  const [logoPreview, setLogoPreview] = useState(null);

  // States for password visibility toggling
  const [showPwd, setShowPwd] = useState(false);
  const [showConfirmPwd, setShowConfirmPwd] = useState(false);

  const navigateToList = () => {
    navigate("/franchise");
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    if (name === "unit") {
      setReferralState((prev) => ({
        ...prev,
        unit: value,
        _unit_: value.replace(/\s+/g, ""),
      }));
    } else {
      setReferralState((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;
    if (file.type !== "image/svg+xml") {
      toast.error("Only SVG files are allowed");
      event.target.value = "";
      return;
    }
    try {
      const uploadedUrl = await AddImage(file);
      if (uploadedUrl) {
        setReferralState((prev) => ({
          ...prev,
          brand_logo: uploadedUrl,
        }));
        setLogoPreview(uploadedUrl);
      }
    } catch (error) {
      toast.error("Image upload failed");
    }
  };

  useEffect(() => {
    // Cleanup preview URL on unmount or logo change
    return () => {
      if (logoPreview) {
        URL.revokeObjectURL(logoPreview);
      }
    };
  }, [logoPreview]);

  useEffect(() => {
    ScrollTop();
    dispatch(viewCountryListPagination());
  }, [dispatch]);

  useEffect(() => {
    if (referralState.country) {
      dispatch(viewStateListPagination({ country: referralState.country }));
      setReferralState((prev) => ({ ...prev, state: "", city: "" }));
    }
  }, [referralState.country, dispatch]);

  useEffect(() => {
    if (referralState.state) {
      dispatch(
        viewCityList({ state: referralState.state, page: 1, limit: 100 })
      );
      setReferralState((prev) => ({ ...prev, city: "" }));
    }
  }, [referralState.state, dispatch]);

  // Send OTP for phone number
  const handleSendOtpForNumber = async () => {
    console.log(
      "Country code:",
      referralState.primary_country_code,
      "Contact number:",
      referralState.primary_contact_number
    );

    if (
      !referralState.primary_country_code ||
      !referralState.primary_contact_number
    ) {
      return toast.error(
        "Please enter country code and contact number to send OTP."
      );
    }
    try {
      const normalizedCountryCode =
        referralState.primary_country_code.startsWith("+")
          ? referralState.primary_country_code
          : "+" + referralState.primary_country_code;

      const response = await dispatch(
        sendFranchiseOtp({
          send_on: "number",
          primary_country_code: normalizedCountryCode,
          primary_contact_number: referralState.primary_contact_number,
        })
      );
      if (response.statusCode === 200) {
        toast.success("OTP sent to contact number");
        setOtpIdNumber(response.data?.otp_id || null);
      }
    } catch (_) {}
  };

  // Send OTP for Email
  const handleSendOtpForEmail = async () => {
    if (!referralState.primary_email) {
      return toast.error("Please enter email to send OTP.");
    }
    try {
      const response = await dispatch(
        sendFranchiseOtp({
          send_on: "email",
          primary_email: referralState.primary_email,
        })
      );
      if (response.statusCode === 200) {
        toast.success("OTP sent to email");
        setOtpIdEmail(response.data?.otp_id || null);
      }
    } catch (_) {}
  };

  // Verify OTP for number
  const handleVerifyOtpForNumber = async () => {
    if (!otpNumber) {
      return toast.error("Please enter OTP for contact number");
    }
    if (!otpIdNumber) {
      return toast.error("Please send OTP first to get OTP ID.");
    }
    try {
      const response = await dispatch(
        verifyFranchiseOtp({
          otp: otpNumber,
          otp_id: otpIdNumber,
          otp_for: "number",
          primary_country_code: referralState.primary_country_code,
          primary_contact_number: referralState.primary_contact_number,
        })
      );
      if (response.statusCode === 200) {
        toast.success("Contact number verified successfully");
        setIsNumberVerified(true);
      }
    } catch (_) {}
  };

  // Verify OTP for email
  const handleVerifyOtpForEmail = async () => {
    if (!otpEmail) {
      return toast.error("Please enter OTP for email");
    }
    if (!otpIdEmail) {
      return toast.error("Please send OTP first to get OTP ID.");
    }
    try {
      const response = await dispatch(
        verifyFranchiseOtp({
          otp: otpEmail,
          otp_id: otpIdEmail,
          otp_for: "email",
          primary_email: referralState.primary_email,
        })
      );
      if (response.statusCode === 200) {
        toast.success("Email verified successfully");
        setIsEmailVerified(true);
      }
    } catch (_) {}
  };

  const handleSubmit = async () => {
    // Name validation
    if (!referralState.brand_name) {
      toast.error("Please enter Franchise Name.");
      return;
    }

    // Logo validation (optional - uncomment if logo is mandatory)
    // if (!referralState.brand_logo) {
    //   toast.error("Please upload a SVG logo.");
    //   return;
    // }

    // Organization Name
    if (!referralState.organization_name) {
      toast.error("Please enter Organization Name.");
      return;
    }

    // Country Code
    if (!referralState.primary_country_code) {
      toast.error("Please select a country code.");
      return;
    }

    // Contact Number
    if (!referralState.primary_contact_number) {
      toast.error("Please enter Contact Number.");
      return;
    }
    if (!/^\d{8,15}$/.test(referralState.primary_contact_number)) {
      toast.error("Contact Number should be 8-15 digits.");
      return;
    }
    if (!isNumberVerified) {
      toast.error("Please verify contact number before submitting.");
      return;
    }

    // Email
    if (!referralState.primary_email) {
      toast.error("Please enter Email.");
      return;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(referralState.primary_email)) {
      toast.error("Please enter a valid email address.");
      return;
    }
    if (!isEmailVerified) {
      toast.error("Please verify email before submitting.");
      return;
    }

    // Address
    if (!referralState.street_address) {
      toast.error("Please enter Address.");
      return;
    }

    // Country
    if (!referralState.country) {
      toast.error("Please select Country.");
      return;
    }

    // State
    if (!referralState.state) {
      toast.error("Please select State.");
      return;
    }

    // City
    if (!referralState.city) {
      toast.error("Please select City.");
      return;
    }

    // Password
    if (!referralState.pwd) {
      toast.error("Please enter Password.");
      return;
    }
    if (referralState.pwd.length < 8) {
      toast.error("Password must be at least 8 characters long.");
      return;
    }
    if (!referralState.confirm_pwd) {
      toast.error("Please confirm Password.");
      return;
    }
    if (referralState.pwd !== referralState.confirm_pwd) {
      toast.error("Password and Confirm Password do not match.");
      return;
    }

    // Optional: RERA ID
    // if (!referralState.rera_id) {
    //   toast.error("Please enter RERA ID.");
    //   return;
    // }

    // Normalized Country Code
    const normalizedCountryCode = referralState.primary_country_code.startsWith(
      "+"
    )
      ? referralState.primary_country_code
      : "+" + referralState.primary_country_code;

    // Prepare payload
    const payload = {
      ...referralState,
      primary_country_code: normalizedCountryCode,
      is_primary_email_verified: isEmailVerified,
      is_primary_contact_number_verified: isNumberVerified,
      created_by: user?.id || user?._id || "defaultAdminId",
    };

    try {
      const response = await dispatch(addFranchise(payload));
      if (response.statusCode === 200) {
        toast.success("Franchise added successfully");
        navigateToList();
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Submit failed");
    }
  };

  const handleContactClick = () => {
    if (!referralState.primary_country_code) {
      toast.error("Please select a country code first.");
    } else if (isNumberVerified) {
      toast.success("Contact number is already verified.");
    }
  };

  return (
    <MainLayout>
      <div className="franchise-form-container">
        <div className="franchise-form-wrapper franchise-card">
          <div className="franchise-card-content">
            <div className="franchise-header">
              <div className="franchise-header-icon">
                <Franchise />
              </div>
              <h1>Add Franchise</h1>
            </div>

            <div className="form-section">
              <TextInput
                label="Name"
                name="brand_name"
                value={referralState.brand_name}
                onChange={handleChange}
                required
                inputClass="form-input"
                labelClass="form-label"
              />
            </div>

            <div className="form-section">
              <label
                className="form-label file-upload-area"
                htmlFor="brand_logo_input"
              >
                Logo
              </label>
              <input
                id="brand_logo_input"
                type="file"
                name="brand_logo"
                accept=".svg"
                onChange={handleFileChange}
                disabled={false}
                className="form-input"
              />

              {logoPreview && (
                <div style={{ marginTop: "10px" }}>
                  <img
                    src={logoPreview}
                    alt="Brand Logo Preview"
                    style={{
                      maxWidth: "200px",
                      maxHeight: "150px",
                      borderRadius: "8px",
                    }}
                  />
                </div>
              )}
            </div>

            <div className="form-section">
              <TextInput
                label="Organization Name"
                name="organization_name"
                value={referralState.organization_name}
                onChange={handleChange}
                required
                inputClass="form-input"
                labelClass="form-label"
              />
            </div>

            {/* COUNTRY CODE FIELD USING react-country-state-city */}
            <div className="form-section">
              <label className="form-label">Country Code *</label>
              <PhonecodeSelect
                placeHolder="Select Country Code"
                value={referralState.primary_country_code}
                onChange={(country) => {
                  if (country && country.phonecode) {
                    const codeWithPlus = country.phonecode.startsWith("+")
                      ? country.phonecode
                      : "+" + country.phonecode;
                    setReferralState((prev) => ({
                      ...prev,
                      primary_country_code: codeWithPlus,
                    }));
                  } else {
                    setReferralState((prev) => ({
                      ...prev,
                      primary_country_code: country ? country.phone_code : "",
                    }));
                  }
                }}
                disabled={isNumberVerified}
                required
              />
            </div>

            <div className="form-cp">
              <div style={{ alignItems: "center" }}>
                <TextInput
                  label="Contact Number"
                  name="primary_contact_number"
                  value={referralState.primary_contact_number}
                  onChange={handleChange}
                  required
                  disabled={
                    isNumberVerified || !referralState.primary_country_code
                  }
                  onClick={handleContactClick}
                  inputClass="form-input"
                  labelClass="form-label"
                />
                {!isNumberVerified && (
                  <>
                    <button
                      className="btn btn-primary"
                      type="button"
                      onClick={handleSendOtpForNumber}
                    >
                      Send OTP
                    </button>
                    <input
                      type="text"
                      placeholder="Enter OTP"
                      value={otpNumber}
                      onChange={(e) => {
                        const val = e.target.value;
                        if (/^\d*$/.test(val)) {
                          // Allows empty or digits only
                          setOtpNumber(val);
                        }
                      }}
                      className="form-input otp-input"
                    />
                    <button
                      className="btn btn-success"
                      type="button"
                      onClick={handleVerifyOtpForNumber}
                      disabled={otpNumber.length !== 4}
                    >
                      Verify
                    </button>
                  </>
                )}
                {isNumberVerified && (
                  <div className="flex-container gap-10 align-center">
                    <span
                      className="success-message"
                      style={{ color: "green" }}
                    >
                      Verified ✓
                    </span>
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={() => {
                        setIsNumberEditable(true);
                        setIsNumberVerified(false);
                        setOtpNumber("");
                      }}
                    >
                      Edit
                    </button>
                  </div>
                )}
              </div>
            </div>

            <div className="form-section form-grid-2">
              <div>
                <TextInput
                  label="Email"
                  name="primary_email"
                  value={referralState.primary_email}
                  onChange={handleChange}
                  required
                  type="email"
                  disabled={isEmailVerified}
                  inputClass="form-input"
                  labelClass="form-label"
                />
              </div>
            </div>
            <div className="form-cp">
              <div style={{ display: "flex", alignItems: "center" }}>
                {!isEmailVerified && (
                  <>
                    <button
                      className="btn btn-primary"
                      type="button"
                      onClick={handleSendOtpForEmail}
                    >
                      Send OTP
                    </button>
                    <input
                      type="text"
                      id="otpEmail"
                      name="otpEmail"
                      placeholder="Enter OTP"
                      value={otpEmail}
                      onChange={(e) => {
                        const val = e.target.value;
                        if (/^\d*$/.test(val)) {
                          setOtpEmail(val);
                        }
                      }}
                      className="form-input otp-input"
                    />

                    <button
                      className="btn btn-success"
                      type="button"
                      onClick={handleVerifyOtpForEmail}
                      disabled={otpEmail.length !== 4}
                    >
                      Verify
                    </button>
                  </>
                )}
                {isEmailVerified && (
                  <div>
                    <span
                      className="success-message"
                      style={{ color: "green" }}
                    >
                      Verified ✓
                    </span>
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={() => {
                        setIsEmailEditable(true);
                        setIsEmailVerified(false);
                        setOtpEmail("");
                      }}
                    >
                      Edit
                    </button>
                  </div>
                )}
              </div>
            </div>

            <div className="form-section">
              <TextInput
                label="Address"
                name="street_address"
                value={referralState.street_address}
                onChange={handleChange}
                required
                inputClass="form-input"
                labelClass="form-label"
              />
            </div>

            <div className="form-section form-grid-3">
              {/* <label className="form-label">
                Select Country */}
              <SelectInput
                label="Select Country"
                placeholder="Select Country"
                value={referralState.country}
                name="country"
                onChange={handleChange}
                required
                options={
                  Array.isArray(countryList?.data)
                    ? countryList.data.map((c) => ({
                        label: c.country_name,
                        value: c._id,
                      }))
                    : []
                }
                selectClass="form-input"
                labelClass="form-label"
                disabled={false}
              />
              {/* </label> */}

              <SelectInput
                label="Select State"
                placeholder="Select State"
                value={referralState.state}
                name="state"
                onChange={handleChange}
                required
                disabled={!referralState.country}
                options={
                  Array.isArray(states?.data)
                    ? states.data.map((s) => ({
                        label: s.state_name,
                        value: s._id,
                      }))
                    : []
                }
                selectClass="form-input"
                labelClass="form-label"
              />

              <SelectInput
                label="Select City"
                placeholder="Select City"
                value={referralState.city}
                name="city"
                onChange={handleChange}
                required
                disabled={!referralState.state}
                options={
                  Array.isArray(cities?.data)
                    ? cities.data.map((c) => ({
                        label: c.city_name,
                        value: c._id,
                      }))
                    : []
                }
                selectClass="form-input"
                labelClass="form-label"
              />
            </div>

            <div className="form-section">
              <TextInput
                id="rera_id"
                label="RERA ID"
                name="rera_id"
                value={referralState.rera_id}
                onChange={handleChange}
                inputClass="form-input"
                labelClass="form-label"
              />
            </div>

            {/* Password fields with eye toggle */}
            <div className="form-section form-grid-2">
              <div style={{ position: "relative" }}>
                <TextInput
                  label="Password"
                  name="pwd"
                  value={referralState.pwd}
                  onChange={handleChange}
                  type={showPwd ? "text" : "password"}
                  required
                  inputClass="form-input"
                  labelClass="form-label"
                />
                <span
                  style={{
                    position: "absolute",
                    right: "10px",
                    top: "38px",
                    cursor: "pointer",
                    zIndex: 2,
                  }}
                  onClick={() => setShowPwd((prev) => !prev)}
                >
                  {showPwd ? <FaEyeSlash /> : <FaEye />}
                </span>
              </div>

              <div style={{ position: "relative" }}>
                <TextInput
                  label="Confirm Password"
                  name="confirm_pwd"
                  value={referralState.confirm_pwd}
                  onChange={handleChange}
                  type={showConfirmPwd ? "text" : "password"}
                  required
                  inputClass="form-input"
                  labelClass="form-label"
                />
                <span
                  style={{
                    position: "absolute",
                    right: "10px",
                    top: "38px",
                    cursor: "pointer",
                    zIndex: 2,
                  }}
                  onClick={() => setShowConfirmPwd((prev) => !prev)}
                >
                  {showConfirmPwd ? <FaEyeSlash /> : <FaEye />}
                </span>
              </div>
            </div>

            <div className="form-navigation">
              <TwoButtons
                buttonHead1="Cancel"
                noUrl={true}
                LinkURL="/franchise"
                onClick2={handleSubmit}
                buttonHead2="Save"
              />
            </div>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default AddFranchise;
